export enum IncentiveIppAchievementValueAction {
  NoAction = 'NoAction',
  Update = 'Update'
}
